'use client';

import { useNavigation, TNavigateToParams } from './use-navigation';

export { useNavigation, type TNavigateToParams };
